import { QuestionCore } from '../../types'

export const TIJDGELD_QUESTIONS: QuestionCore[] = [
  {
    id: 'TIJD-PAT-L1-001',
    module: 'TijdGeld',
    difficulty: 1,
    question: 'Kijk naar de rij: 3 - 7 - 11 - 15 - ... Welk getal komt daarna?',
    options: ['19', '16', '18', '20'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-TAB-L1-001',
    module: 'TijdGeld',
    difficulty: 1,
    question:
      'In een tabel staat: Maandag 5 graden, Dinsdag 8 graden, Woensdag 6 graden. Op welke dag was het het warmst?',
    options: ['Dinsdag', 'Maandag', 'Woensdag', 'Alle dagen gelijk'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-DUR-L2-001',
    module: 'TijdGeld',
    difficulty: 2,
    question:
      'De trein vertrekt elk half uur. De eerste trein gaat om 09:15. Hoe laat gaat de volgende?',
    options: ['09:45', '09:30', '10:15', '09:55'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-PAT-L2-001',
    module: 'TijdGeld',
    difficulty: 2,
    question:
      'Toms zakgeld: Week 1: €2. Week 2: €4. Week 3: €6. Hoeveel krijgt hij in Week 5?',
    options: ['€ 10', '€ 8', '€ 12', '€ 5'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-TAB-L3-001',
    module: 'TijdGeld',
    difficulty: 3,
    question:
      'Op de menukaart staat: Pannenkoek € 5,00. Toeslag spek: + € 1,50. Toeslag kaas: + € 1,00. Je bestelt een pannenkoek met spek én kaas. Wat betaal je?',
    options: ['€ 7,50', '€ 6,50', '€ 6,00', '€ 8,50'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-TAB-L3-002',
    module: 'TijdGeld',
    difficulty: 3,
    question:
      'Afstandstabel: Van A naar B is 10 km. Van B naar C is 5 km. Van A naar C (via B) is ... km?',
    options: ['15 km', '5 km', '50 km', '20 km'],
    correctAnswer: 0,
  },

  // Klokkijken tot op de seconde
  {
    id: 'TIJD-KLOK-L1-001',
    module: 'TijdGeld',
    difficulty: 1,
    question: 'Hoeveel seconden zitten er in 1 minuut?',
    options: ['60 seconden', '100 seconden', '30 seconden', '120 seconden'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-KLOK-L1-002',
    module: 'TijdGeld',
    difficulty: 1,
    question: 'De digitale klok toont: 14:30:00. Hoe laat is het?',
    options: [
      "Half drie 's middags",
      "Half twee 's middags",
      "Drie uur 's middags",
      "Half vier 's middags",
    ],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-KLOK-L1-003',
    module: 'TijdGeld',
    difficulty: 1,
    question: 'Hoeveel seconden zitten er in een half minuut?',
    options: ['30 seconden', '60 seconden', '15 seconden', '45 seconden'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-KLOK-L2-001',
    module: 'TijdGeld',
    difficulty: 2,
    question:
      'De klok toont 09:15:30. Hoeveel seconden is het na kwart over negen?',
    options: ['30 seconden', '15 seconden', '45 seconden', '1 minuut'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-KLOK-L2-002',
    module: 'TijdGeld',
    difficulty: 2,
    question:
      'Een race duurt 2 minuten en 45 seconden. Hoeveel seconden is dat in totaal?',
    options: ['165 seconden', '145 seconden', '245 seconden', '125 seconden'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-KLOK-L2-003',
    module: 'TijdGeld',
    difficulty: 2,
    question:
      'De klok staat op 11:58:40. Over hoeveel seconden is het 12:00:00?',
    options: ['80 seconden', '60 seconden', '120 seconden', '20 seconden'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-KLOK-L3-001',
    module: 'TijdGeld',
    difficulty: 3,
    question:
      'Een atleet loopt 400 meter in 58,75 seconden. Hoeveel is dat in minuten en seconden?',
    options: [
      '0 minuten en 58,75 seconden',
      '58 minuten en 75 seconden',
      '5 minuten en 8,75 seconden',
      '0 minuten en 59 seconden',
    ],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-KLOK-L3-002',
    module: 'TijdGeld',
    difficulty: 3,
    question:
      'De klok toont 23:59:45. Over hoeveel seconden begint de nieuwe dag?',
    options: ['15 seconden', '45 seconden', '60 seconden', '30 seconden'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-KLOK-L3-003',
    module: 'TijdGeld',
    difficulty: 3,
    question:
      'Een liedje duurt 3 minuten en 15 seconden. Hoeveel seconden is dat in totaal?',
    options: ['195 seconden', '315 seconden', '180 seconden', '215 seconden'],
    correctAnswer: 0,
  },

  // Geld vragen
  {
    id: 'TIJD-GELD-L1-001',
    module: 'TijdGeld',
    difficulty: 1,
    questionType: 'geld_samenstellen',
    question: 'Je hebt €2,50. Hoeveel munten van 50 cent heb je nodig?',
    options: ['5 munten', '4 munten', '3 munten', '2 munten'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-GELD-L2-001',
    module: 'TijdGeld',
    difficulty: 2,
    questionType: 'geld_samenstellen',
    question:
      'Je wilt €7 betalen. Je hebt een biljet van €5 en munten van €1. Hoeveel munten van €1 heb je nodig?',
    options: [
      '2 munten van €1',
      '3 munten van €1',
      '5 munten van €1',
      '7 munten van €1',
    ],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-GELD-L2-002',
    module: 'TijdGeld',
    difficulty: 2,
    questionType: 'geld_samenstellen',
    question: 'Welke combinatie geeft precies €3,75?',
    options: [
      '1 biljet van €5 + 1 munt van €1 + 1 munt van 50¢ + 1 munt van 25¢',
      '3 biljetten van €1 + 3 munten van 25¢',
      '3 biljetten van €1 + 1 munt van 50¢ + 1 munt van 25¢',
      '7 munten van 50¢ + 1 munt van 25¢',
    ],
    correctAnswer: 2,
  },
  {
    id: 'TIJD-GELD-L2-003',
    module: 'TijdGeld',
    difficulty: 2,
    questionType: 'geld_hergroeperen',
    question:
      'Je koopt iets van €3,75. Je betaalt met €5. Hoeveel krijg je terug?',
    options: ['€1,25', '€1,50', '€2,25', '€1,75'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-GELD-L3-001',
    module: 'TijdGeld',
    difficulty: 3,
    questionType: 'geld_hergroeperen',
    question:
      'Een broodje kost €2,85. Je betaalt met een biljet van €10. Welk wisselgeld krijg je het slimst terug (minste aantal briefjes en munten)?',
    options: [
      '1 biljet van €5, 2 biljetten van €1, 1 munt van 10¢, 1 munt van 5¢',
      '7 biljetten van €1, 1 munt van 10¢, 1 munt van 5¢',
      '1 biljet van €5, 1 biljet van €2, 1 munt van 10¢, 1 munt van 5¢',
      '14 munten van 50¢, 1 munt van 10¢, 1 munt van 5¢',
    ],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-GELD-L1-002',
    module: 'TijdGeld',
    difficulty: 1,
    questionType: 'geld_samenstellen',
    question: 'Je hebt 3 munten van €1. Hoeveel euro heb je in totaal?',
    options: ['€3', '€2', '€4', '€1'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-GELD-L1-003',
    module: 'TijdGeld',
    difficulty: 1,
    questionType: 'geld_samenstellen',
    question:
      'Een snoepje kost 25 cent. Je geeft 50 cent. Hoeveel krijg je terug?',
    options: ['25 cent', '50 cent', '75 cent', '0 cent'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-GELD-L1-004',
    module: 'TijdGeld',
    difficulty: 1,
    questionType: 'geld_samenstellen',
    question: 'Je hebt 2 munten van 50 cent. Hoeveel euro is dat?',
    options: ['€1', '€2', '50 cent', '€1,50'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-GELD-L1-005',
    module: 'TijdGeld',
    difficulty: 1,
    questionType: 'geld_samenstellen',
    question: 'Een broodje kost €2. Je hebt 2 munten van €1. Kun je het kopen?',
    options: [
      'Ja, precies genoeg',
      'Nee, te weinig',
      'Ja, met geld over',
      'Kan niet',
    ],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-GELD-L2-004',
    module: 'TijdGeld',
    difficulty: 2,
    questionType: 'geld_samenstellen',
    question:
      'Je wilt €5,50 betalen. Je hebt een biljet van €5 en munten van 50 cent. Hoeveel munten heb je nodig?',
    options: ['1 munt', '2 munten', '3 munten', '0 munten'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-GELD-L2-005',
    module: 'TijdGeld',
    difficulty: 2,
    questionType: 'geld_hergroeperen',
    question:
      'Een ijsje kost €1,80. Je betaalt met €2. Hoeveel krijg je terug?',
    options: ['20 cent', '30 cent', '10 cent', '40 cent'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-GELD-L2-006',
    module: 'TijdGeld',
    difficulty: 2,
    questionType: 'geld_samenstellen',
    question: 'Je hebt 4 munten van €2. Hoeveel euro heb je?',
    options: ['€8', '€6', '€4', '€10'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-GELD-L2-007',
    module: 'TijdGeld',
    difficulty: 2,
    questionType: 'geld_hergroeperen',
    question:
      'Een boek kost €12,50. Je betaalt met een biljet van €20. Hoeveel krijg je terug?',
    options: ['€7,50', '€8,50', '€6,50', '€7'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-GELD-L2-008',
    module: 'TijdGeld',
    difficulty: 2,
    questionType: 'geld_samenstellen',
    question: 'Welke combinatie geeft precies €2,50?',
    options: [
      '2 munten van €1 + 1 munt van 50¢',
      '5 munten van 50¢',
      '1 munt van €2 + 2 munten van 25¢',
      'Alle bovenstaande',
    ],
    correctAnswer: 3,
  },
  {
    id: 'TIJD-GELD-L3-002',
    module: 'TijdGeld',
    difficulty: 3,
    questionType: 'geld_hergroeperen',
    question:
      'Je koopt 3 pennen van €1,45 per stuk. Je betaalt met een biljet van €5. Hoeveel krijg je terug?',
    options: ['€0,65', '€1,65', '€0,55', '€1,55'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-GELD-L3-003',
    module: 'TijdGeld',
    difficulty: 3,
    questionType: 'geld_samenstellen',
    question:
      'Je wilt €15,75 betalen met zo min mogelijk briefjes en munten. Welke combinatie gebruik je?',
    options: [
      '1×€10, 1×€5, 1×50¢, 1×25¢',
      '3×€5, 1×50¢, 1×25¢',
      '15×€1, 3×25¢',
      '1×€10, 5×€1, 3×25¢',
    ],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-GELD-L3-004',
    module: 'TijdGeld',
    difficulty: 3,
    questionType: 'geld_hergroeperen',
    question:
      'Een speelgoed kost €23,95. Je betaalt met 2 biljetten van €20. Hoeveel krijg je terug?',
    options: ['€16,05', '€6,05', '€26,05', '€36,05'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-GELD-L3-005',
    module: 'TijdGeld',
    difficulty: 3,
    questionType: 'geld_samenstellen',
    question:
      'Je hebt 8 munten van €2, 5 munten van €1 en 4 munten van 50¢. Hoeveel heb je in totaal?',
    options: ['€23', '€21', '€25', '€19'],
    correctAnswer: 0,
  },
  {
    id: 'TIJD-GELD-L3-006',
    module: 'TijdGeld',
    difficulty: 3,
    questionType: 'geld_hergroeperen',
    question:
      'Een game kost €34,99. Je spaart elke week €5. Na hoeveel weken kun je de game kopen?',
    options: ['7 weken', '6 weken', '8 weken', '5 weken'],
    correctAnswer: 0,
  },
]
